module.exports = __webpack_public_path__ + "img/icon_unselected_lion.819241b2.png";